import Helper from "@ember/component/helper"
import _ from "lodash"

export function indexOf(params) {
  let array = params[0]
  let item = params[1]
  return _.indexOf(array, item)
}

export default class IndexOf extends Helper {
  compute = indexOf
}
